import { useBookEditor } from "./BookEditorProvider";

/** Turn 1 stub — selection-aware inspector expands in Turn 4. */
export default function BookEditorInspector() {
  const { mode, selection, activeChapter } = useBookEditor();
  if (mode === "write" || mode === "canvas") return null;
  return (
    <aside className="book-editor-inspector" data-testid="book-editor-inspector">
      <h3>Inspector</h3>
      {selection?.ids?.length ? (
        <p>
          Selected {selection.type}: {selection.ids.join(", ")}
        </p>
      ) : (
        <p>
          {activeChapter
            ? `Chapter: ${activeChapter.title}`
            : "Nothing selected"}
        </p>
      )}
    </aside>
  );
}
